export const environment = {

    stage:'dev',
    api_url:"https://dev.api.salesbackoffice.betoparedes.com/",
    bp_redirectURl:"https://dev.frontend.betoparedes.com/watch-presentation?ndasign=true"
  
  };